import { render, staticRenderFns } from "./OakDialog.vue?vue&type=template&id=71fec364&scoped=true"
import script from "./OakDialog.vue?vue&type=script&lang=js"
export * from "./OakDialog.vue?vue&type=script&lang=js"
import style0 from "./OakDialog.vue?vue&type=style&index=0&id=71fec364&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fec364",
  null
  
)

export default component.exports